<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  count: Number,
  length: Number,
})


const calculatedWidth = computed(() => {
  return {width: `${(props.count / props.length) * 100}%`};
});
</script>
<template>
  <div class="progress mt-3 mb-3">
    <div id="admin-action-progress-bar" class="progress-bar progress-bar-striped progress-bar-animated ${data.style}"
         role="progressbar" :style="calculatedWidth" aria-valuenow=""
         aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</template>